__turbopack_context__.v({
  "accordionSlideOverwrite": "switch-module-scss-module__Nb_raW__accordionSlideOverwrite",
  "fadeIn": "switch-module-scss-module__Nb_raW__fadeIn",
  "fadeOut": "switch-module-scss-module__Nb_raW__fadeOut",
  "scaleIn": "switch-module-scss-module__Nb_raW__scaleIn",
  "scaleOut": "switch-module-scss-module__Nb_raW__scaleOut",
  "switchRoot": "switch-module-scss-module__Nb_raW__switchRoot",
  "switchThumb": "switch-module-scss-module__Nb_raW__switchThumb",
  "zoomIn": "switch-module-scss-module__Nb_raW__zoomIn",
  "zoomOut": "switch-module-scss-module__Nb_raW__zoomOut",
});
